import { Injectable } from '@angular/core';
import {
  IPipelinePagination,
  IPipeline,
  IPipelineState,
} from '../models/pipeline.model';
import { IBaseTableResult } from '../models/table.model';
import { Observable, forkJoin, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PipelineService {
  getPipelines(pagination: IPipelinePagination): Observable<{
    pipelines: IPipeline[];
    pagination: IPipelinePagination;
  }> {
    return forkJoin(this.getPipelinesList(pagination)).pipe(
      map(res => {
        return {
          pipelines: res[0].items,
          pagination: {
            current_page: res[0].current_page,
            has_more_data: res[0].has_more_data,
            page_size: res[0].current_page_size,
            total_pages_count: res[0].total_page_count,
          },
        };
      })
    );
  }

  getPipelinesList(
    pagination: IPipelinePagination,
    defaultOnly: boolean = false
  ): Observable<any> {
    return this.http.get<IBaseTableResult<IPipeline>>(
      environment.apiUrl + '/v1/pipelines',
      {
        params: {
          only_enabled: 'true',
          dropdown_list: String(defaultOnly),
          page_size: pagination.page_size.toString(),
          page: pagination.current_page.toString(),
          paginated: 'false',
        },
      }
    );
  }

  createPipeline(pipeline) {
    return this.http.post(environment.apiUrl + '/v1/pipelines', pipeline);
  }

  updatePipeline(pipeline) {
    return this.http.put(
      environment.apiUrl + '/v1/pipelines/' + pipeline.id,
      pipeline
    );
  }

  deletePipeline(pipeline) {
    return this.http.delete(
      environment.apiUrl + '/v1/pipelines/' + pipeline.id
    );
  }

  constructor(private http: HttpClient) {}
}
